import React from 'react';

export function App() {
  return (
    <main style={{ fontFamily: 'Arial, sans-serif', padding: '24px' }}>
      <h1>Boilerplate External Web - Test</h1>
      <p>Deployment test.</p>
    </main>
  );
}